import { Action, initialState, State } from "store/store";

export const setThemeId = (state: State = initialState, { data }: Action): State => {
  const nextState = {
    ...state,
    themeId: (data as unknown) as string,
  };

  return nextState;
};
